// Centralised translations for CIEES Portugal — PT / EN / ES
export const translations = {
  pt: {
    nav: {
      home: "Início",
      about: "Quem Somos",
      communities: "Comunidades",
      spirituality: "Espiritualidade",
      miami: "Congresso Miami",
      presentation: "Apresentação 2026",
      events: "Eventos",
      contact: "Contactos",
      support: "Apoiar",
    },
    common: {
      learnMore: "Saber mais",
      register: "Inscrever-me",
      send: "Enviar",
      sending: "A enviar…",
      submit: "Submeter",
      thankYou: "Obrigado!",
      backHome: "Voltar ao início",
      required: "Obrigatório",
      optional: "(opcional)",
      yes: "Sim",
      no: "Não",
      readPrayer: "Ler a oração",
      downloadStatutes: "Descarregar estatutos",
    },
    home: {
      overline: "Comunidade · Liderança · Aliança",
      heroTitle: "Schoenstatt no trabalho.",
      heroSubtitle:
        "Empresários e executivos que vivem a Aliança de Amor com Maria, ao serviço de uma economia mais humana, mais justa e mais inspirada.",
      ctaPrimary: "Apresentação · Setembro 2026",
      ctaSecondary: "Conhecer o CIEES",
      sectionAboutOverline: "A nossa missão",
      sectionAboutTitle:
        "Líderes inspiradores que humanizam o mundo do trabalho.",
      sectionAboutBody:
        "O CIEES Portugal nasceu a 30 de Março de 2026, em Lisboa, como ramo nacional da Comunidade Internacional de Empresários e Executivos Schoenstattianos. Inspiramo-nos na pedagogia do Padre José Kentenich para construir uma cultura empresarial alicerçada em fé, dignidade e bem comum.",
      pillars: [
        { title: "Auto-educação", body: "Propomos itinerários de auto-educação para empresários e executivos viverem a Cultura da Aliança." },
        { title: "Comunidade", body: "Fomentamos comunidades locais e a comunhão entre líderes." },
        { title: "Retiros", body: "Promovemos retiros e encontros de reflexão à luz da pedagogia kentenichiana." },
        { title: "Testemunho", body: "Transformamos a sociedade através do testemunho coerente dos membros." },
      ],
      eventsOverline: "Próximos passos",
      eventsTitle: "Dois encontros para colocar na agenda.",
      septCard: {
        date: "Setembro 2026 · Lisboa",
        title: "Apresentação Formal aos Empresários Portugueses",
        body: "Um encontro para apresentar oficialmente o CIEES Portugal à comunidade empresarial nacional e convidar os primeiros associados.",
        cta: "Inscrever interesse",
      },
      miamiCard: {
        date: "Setembro 2027 · Miami, EUA",
        title: "Congresso CIEES Internacional",
        body: "O encontro internacional bienal que reúne os ramos do CIEES em todo o mundo. Portugal estará presente.",
        cta: "Saber mais",
      },
      quoteOverline: "A nossa missão",
      quote:
        "“Inspirar, evangelizar e humanizar o mundo do trabalho, através do exemplo e do serviço.”",
      quoteAuthor: "CIEES Portugal",
    },
    about: {
      overline: "Quem somos",
      title:
        "Uma associação nova, com uma raiz centenária.",
      lead:
        "O CIEES Portugal — Comunidade Internacional de Empresários e Executivos Schoenstattianos é uma associação privada sem fins lucrativos, de inspiração cristã católica e de raiz schoenstattiana, com sede em Lisboa.",
      historyTitle: "História",
      history:
        "A 30 de Março de 2026, oito empresários e executivos portugueses outorgaram a escritura da associação. Reunimo-nos depois no Santuário de Schoenstatt para consagrar simbolicamente a obra à Mãe Três Vezes Admirável. O ramo português integra a rede internacional do CIEES, com presença em vários países da América Latina e da Europa.",
      missionTitle: "Missão",
      mission:
        "Promover a vivência e a aplicação da espiritualidade e pedagogia de Schoenstatt no mundo do trabalho e da empresa — inspirando, evangelizando e humanizando, através do exemplo e do serviço.",
      finalitiesTitle: "Finalidades",
      finalities: [
        "Propor itinerários de auto-educação para empresários, executivos e líderes viverem a Cultura da Aliança de Amor e a pedagogia kentenichiana.",
        "Fomentar comunidades locais de empresários e executivos.",
        "Estudar, aprofundar e aplicar a Doutrina Social da Igreja no contexto empresarial.",
        "Promover retiros, encontros de reflexão e comunhão.",
        "Contribuir para a transformação da sociedade a partir do mundo do trabalho.",
        "Colaborar com o Movimento de Schoenstatt, dioceses e instituições afins.",
      ],
      foundersTitle: "Fundadores",
      founders: [
        { name: "Paulo Jorge de Matos Galvão", role: "Presidente" },
        { name: "Pedro Gonçalves Marques", role: "Vice-Presidente" },
        { name: "Manuel Máximo Canavarro Menres Mendes de Almeida", role: "Presidente da Assembleia" },
        { name: "Hugo Emanuel Ferreira Neves Chambel", role: "Presidente do Conselho Fiscal" },
        { name: "Carlos de Avelar da Costa Freire Correia", role: "Direção Executiva" },
        { name: "Gonçalo Machado Mendes Barata", role: "Financeiro" },
        { name: "João Pedro Magalhães Paleta", role: "Educação" },
        { name: "José Pedro Rosa Henriques Mendonça", role: "Espiritualidade" },
        { name: "Ana Isabel Nunes Martins", role: "Comunicação" },
      ],
      spiritualAdvisorTitle: "Assessor Espiritual",
      spiritualAdvisor: "Pe. Borja Coelho de Portugal",
      seatTitle: "Sede",
      seatBody: "Praça Damão, 7 · 1400-085 Lisboa · Portugal",
      mandate: "Mandato presidencial: 3 anos",
    },
    spirituality: {
      overline: "Espiritualidade",
      title: "Aliança de Amor com Maria, ao serviço do trabalho.",
      lead:
        "Schoenstatt é um movimento católico fundado em 1914 pelo Padre José Kentenich. A sua espiritualidade centra-se na Aliança de Amor com Maria, na fé prática na Divina Providência e numa pedagogia que forma personalidades livres, firmes e apostólicas.",
      shrineTitle: "O Santuário",
      shrineBody:
        "Cada Santuário de Schoenstatt é um lugar de graça, onde se vive uma especial presença de Maria como Mãe, Rainha e Vencedora Três Vezes Admirável. Foi no Santuário, em Lisboa, que entregámos simbolicamente a escritura do CIEES Portugal.",
      covenantTitle: "A Aliança de Amor",
      covenantBody:
        "No coração da espiritualidade de Schoenstatt está a Aliança de Amor com Maria — um compromisso pessoal e comunitário de confiança mútua. Damos o nosso pequeno contributo de oração, sacrifício e fidelidade; recebemos d’Ela a fecundidade que nos transforma e à nossa missão no mundo do trabalho.",
      pedagogyTitle: "Pedagogia kentenichiana",
      pedagogyBody:
        "A pedagogia do Padre José Kentenich é uma pedagogia de vínculos, de ideal pessoal e de fé prática na Divina Providência. Forma personalidades livres, firmes e apostólicas — capazes de viver com coerência o Evangelho no quotidiano profissional.",
      itinerariesTitle: "O que propomos",
      itinerariesBody:
        "Não somos uma escola nem damos cursos de formação. Propomos itinerários de auto-educação — caminhos pessoais e comunitários que cada empresário e executivo percorre, no seu ritmo, em comunidade — complementados por retiros e encontros de reflexão à luz da espiritualidade de Schoenstatt.",
      itinerariesPoints: [
        "Itinerários pessoais de auto-educação",
        "Retiros e encontros de reflexão",
        "Comunidades locais de partilha",
        "Acompanhamento espiritual",
      ],
    },
    miami: {
      overline: "Evento internacional",
      title: "Congresso CIEES Internacional",
      where: "Miami · Estados Unidos da América",
      when: "Setembro 2026",
      lead:
        "O encontro internacional bienal que reúne todos os ramos do CIEES no mundo — para encontros, comunhão, troca de experiências e definição de rumo comum.",
      portugalDelegation:
        "Portugal participará pela primeira vez como ramo nacional, levando uma delegação de empresários e executivos que abraçam a missão.",
      interestTitle: "Manifestar interesse em participar",
      interestBody:
        "Se gostaria de se juntar à delegação portuguesa em Miami, deixe os seus dados. Iremos contactá-lo(a) com os detalhes finais de programa, alojamento e investimento.",
    },
    presentation: {
      overline: "Apresentação aos empresários portugueses",
      title: "Setembro 2026 · Lisboa",
      lead:
        "Um encontro formal para apresentar o CIEES Portugal à comunidade empresarial nacional. Será uma noite de reflexão, comunhão e missão — para que mais empresários e executivos descubram esta nova casa.",
      details: [
        { label: "Quando", value: "Setembro 2026 (data confirmada em breve)" },
        { label: "Onde", value: "Lisboa — local a anunciar" },
        { label: "Duração", value: "A confirmar" },
        { label: "Convite", value: "Por inscrição (vagas limitadas)" },
      ],
      formTitle: "Reservar o seu lugar",
      formIntro:
        "Preencha o formulário abaixo para reservar a sua presença. Receberá um email de confirmação e, mais perto da data, os detalhes finais.",
      fields: {
        fullName: "Nome completo",
        email: "Email",
        phone: "Telemóvel",
        company: "Empresa",
        role: "Cargo / Função",
        dietary: "Restrições alimentares",
        bringGuest: "Acompanhante",
        guestName: "Nome do acompanhante",
        message: "Mensagem (opcional)",
      },
      successTitle: "Inscrição registada com gratidão.",
      successBody:
        "Acabámos de enviar uma confirmação para o seu email. Em breve receberá os detalhes finais. Que Maria nos conduza.",
    },
    downloads: {
      overline: "Documentos",
      title: "Os documentos fundadores",
      lead: "Toda a obra deixa rasto. Aqui pode descarregar os documentos que fundam a nossa comunidade.",
      items: [
        {
          title: "Estatutos assinados",
          description: "O texto integral dos estatutos do CIEES Portugal, aprovado pelos fundadores.",
          file: "https://customer-assets.emergentagent.com/job_f05fff24-1793-4250-930b-537d899538c3/artifacts/aep30toa_Estatutos%20CIEES%20Portugal%20assinados.pdf",
        },
        {
          title: "Escritura de Constituição",
          description: "Escritura pública lavrada a 30 de Março de 2026.",
          file: "https://customer-assets.emergentagent.com/job_f05fff24-1793-4250-930b-537d899538c3/artifacts/0mphspgo_Escrtura%20CIEES%20Portugal%20dia%203003%202026.pdf",
        },
      ],
    },
    contact: {
      overline: "Contactos",
      title: "Diga olá.",
      lead:
        "Para empresários e executivos interessados em conhecer o CIEES, para imprensa ou para a Igreja — escreva-nos. Respondemos sempre.",
      fields: { name: "Nome", email: "Email", subject: "Assunto", message: "Mensagem" },
      successTitle: "Mensagem enviada.",
      successBody: "Recebemos a sua mensagem e responderemos com brevidade.",
      seat: "Sede",
      seatBody: "Praça Damão, 7 · 1400-085 Lisboa · Portugal",
    },
    newsletter: {
      title: "Acompanhe a comunidade",
      body: "Receba notícias, reflexões e datas relevantes do CIEES Portugal.",
      namePlaceholder: "O seu nome (opcional)",
      placeholder: "O seu email",
      cta: "Subscrever",
      success: "Subscrito. Obrigado!",
    },
    footer: {
      tagline: "Schoenstatt no trabalho.",
      links: "Páginas",
      legal: "Institucional",
      seat: "Sede",
      privacy: "Privacidade",
      copyright: "© 2026 CIEES Portugal · Todos os direitos reservados.",
    },
  },
  en: {
    nav: {
      home: "Home",
      about: "About",
      communities: "Communities",
      spirituality: "Spirituality",
      miami: "Miami Congress",
      presentation: "Sept. 2026 Event",
      events: "Events",
      contact: "Contact",
      support: "Donate",
    },
    common: {
      learnMore: "Learn more",
      register: "Register",
      send: "Send",
      sending: "Sending…",
      submit: "Submit",
      thankYou: "Thank you!",
      backHome: "Back home",
      required: "Required",
      optional: "(optional)",
      yes: "Yes",
      no: "No",
      readPrayer: "Read the prayer",
      downloadStatutes: "Download statutes",
    },
    home: {
      overline: "Community · Leadership · Covenant",
      heroTitle: "Schoenstatt at work.",
      heroSubtitle:
        "Entrepreneurs and executives who live the Covenant of Love with Mary, in service of a more human, just and inspired economy.",
      ctaPrimary: "September 2026 event",
      ctaSecondary: "Discover CIEES",
      sectionAboutOverline: "Our mission",
      sectionAboutTitle: "Inspiring leaders who humanise the world of work.",
      sectionAboutBody:
        "CIEES Portugal was founded on March 30, 2026 in Lisbon, as the national branch of the International Community of Schoenstatt Entrepreneurs and Executives. We are inspired by the pedagogy of Father Joseph Kentenich to build a business culture grounded in faith, dignity and the common good.",
      pillars: [
        { title: "Self-education", body: "We propose self-education itineraries for entrepreneurs and executives to live the Culture of the Covenant." },
        { title: "Community", body: "We foster local communities and communion among leaders." },
        { title: "Retreats", body: "We organise retreats and reflection encounters in the light of Kentenichian pedagogy." },
        { title: "Witness", body: "We transform society through the coherent witness of our members." },
      ],
      eventsOverline: "Next steps",
      eventsTitle: "Two milestones to put on the calendar.",
      septCard: {
        date: "September 2026 · Lisbon",
        title: "Formal Presentation to Portuguese Entrepreneurs",
        body: "An evening to officially present CIEES Portugal to the national business community and welcome the first members.",
        cta: "Register interest",
      },
      miamiCard: {
        date: "September 2027 · Miami, USA",
        title: "CIEES International Congress",
        body: "The biennial international gathering that brings together CIEES branches around the world. Portugal will attend.",
        cta: "Learn more",
      },
      quoteOverline: "Our mission",
      quote:
        "“To inspire, evangelise and humanise the world of work — through example and service.”",
      quoteAuthor: "CIEES Portugal",
    },
    about: {
      overline: "About",
      title: "A new association, with a hundred-year-old root.",
      lead:
        "CIEES Portugal — International Community of Schoenstatt Entrepreneurs and Executives — is a private non-profit association of Catholic Christian inspiration and Schoenstatt roots, headquartered in Lisbon.",
      historyTitle: "History",
      history:
        "On March 30, 2026, eight Portuguese entrepreneurs and executives signed the founding deed. We then gathered at the Schoenstatt Shrine to symbolically consecrate the work to the Thrice Admirable Mother. The Portuguese branch is part of CIEES’s international network, with presence in several Latin American and European countries.",
      missionTitle: "Mission",
      mission:
        "To promote the living and application of Schoenstatt spirituality and pedagogy in the world of work and business — inspiring, evangelising and humanising through example and service.",
      finalitiesTitle: "Purposes",
      finalities: [
        "Propose self-education itineraries for entrepreneurs, executives and leaders to live the Culture of the Covenant of Love and Kentenichian pedagogy.",
        "Foster local communities of entrepreneurs and executives.",
        "Study, deepen and apply the Social Doctrine of the Church to business.",
        "Organise retreats, reflection encounters and communion.",
        "Contribute to the transformation of society from the world of work.",
        "Collaborate with the Schoenstatt Movement, dioceses and related institutions.",
      ],
      foundersTitle: "Founders",
      founders: [
        { name: "Paulo Jorge de Matos Galvão", role: "President" },
        { name: "Pedro Gonçalves Marques", role: "Vice-President" },
        { name: "Manuel Máximo Canavarro Menres Mendes de Almeida", role: "Chair of the Assembly" },
        { name: "Hugo Emanuel Ferreira Neves Chambel", role: "Chair of the Audit Board" },
        { name: "Carlos de Avelar da Costa Freire Correia", role: "Executive Director" },
        { name: "Gonçalo Machado Mendes Barata", role: "Finance" },
        { name: "João Pedro Magalhães Paleta", role: "Education" },
        { name: "José Pedro Rosa Henriques Mendonça", role: "Spirituality" },
        { name: "Ana Isabel Nunes Martins", role: "Communications" },
      ],
      spiritualAdvisorTitle: "Spiritual Advisor",
      spiritualAdvisor: "Fr. Borja Coelho de Portugal",
      seatTitle: "Seat",
      seatBody: "Praça Damão, 7 · 1400-085 Lisbon · Portugal",
      mandate: "Presidential term: 3 years",
    },
    spirituality: {
      overline: "Spirituality",
      title: "Covenant of Love with Mary, at the service of work.",
      lead:
        "Schoenstatt is a Catholic movement founded in 1914 by Father Joseph Kentenich. Its spirituality is centred on the Covenant of Love with Mary, practical faith in Divine Providence and a pedagogy that forms free, firm and apostolic personalities.",
      shrineTitle: "The Shrine",
      shrineBody:
        "Every Schoenstatt Shrine is a place of grace, where a special presence of Mary as Mother, Queen and Thrice Admirable Victress is lived. It was at the Shrine, in Lisbon, that we symbolically presented the founding deed of CIEES Portugal.",
      covenantTitle: "The Covenant of Love",
      covenantBody:
        "At the heart of Schoenstatt spirituality is the Covenant of Love with Mary — a personal and communal commitment of mutual trust. We bring our small contribution of prayer, sacrifice and fidelity; from Her we receive the fruitfulness that transforms us and our mission in the world of work.",
      pedagogyTitle: "Kentenichian pedagogy",
      pedagogyBody:
        "Father Joseph Kentenich’s pedagogy is a pedagogy of bonds, of personal ideal and practical faith in Divine Providence. It forms free, firm and apostolic personalities — able to live the Gospel coherently in everyday professional life.",
      itinerariesTitle: "What we propose",
      itinerariesBody:
        "We are not a school and we do not deliver training courses. We propose self-education itineraries — personal and communal paths that each entrepreneur and executive walks, at their own pace, in community — complemented by retreats and encounters of reflection in the light of Schoenstatt spirituality.",
      itinerariesPoints: [
        "Personal self-education itineraries",
        "Retreats and reflection encounters",
        "Local sharing communities",
        "Spiritual accompaniment",
      ],
    },
    miami: {
      overline: "International event",
      title: "CIEES International Congress",
      where: "Miami · United States",
      when: "September 2027",
      lead:
        "The biennial international gathering that brings together every CIEES branch in the world — for formation, communion, exchange and shared direction.",
      portugalDelegation:
        "Portugal will attend for the first time as a national branch, with a delegation of entrepreneurs and executives who embrace the mission.",
      interestTitle: "Express interest in attending",
      interestBody:
        "If you would like to join the Portuguese delegation in Miami, leave us your details. We will contact you with the final programme, accommodation and investment information.",
    },
    presentation: {
      overline: "Presentation to Portuguese entrepreneurs",
      title: "September 2026 · Lisbon",
      lead:
        "A formal evening to introduce CIEES Portugal to the national business community. An evening of reflection, communion and mission — so that more entrepreneurs and executives may discover this new home.",
      details: [
        { label: "When", value: "September 2026 (date to be confirmed)" },
        { label: "Where", value: "Lisbon — venue to be announced" },
        { label: "Duration", value: "To be confirmed" },
        { label: "Invitation", value: "By registration (limited seats)" },
      ],
      formTitle: "Reserve your seat",
      formIntro:
        "Fill in the form below to reserve your place. You will receive a confirmation email and, closer to the date, the final details.",
      fields: {
        fullName: "Full name",
        email: "Email",
        phone: "Mobile",
        company: "Company",
        role: "Role",
        dietary: "Dietary restrictions",
        bringGuest: "Bringing a guest?",
        guestName: "Guest name",
        message: "Message (optional)",
      },
      successTitle: "Registration received with gratitude.",
      successBody:
        "We have just sent a confirmation to your email. The final details will follow shortly. May Mary lead us.",
    },
    downloads: {
      overline: "Documents",
      title: "Founding documents",
      lead: "Every work leaves a trace. Download the documents that found our community.",
      items: [
        {
          title: "Signed statutes",
          description: "Full text of CIEES Portugal statutes, approved by the founders.",
          file: "https://customer-assets.emergentagent.com/job_f05fff24-1793-4250-930b-537d899538c3/artifacts/aep30toa_Estatutos%20CIEES%20Portugal%20assinados.pdf",
        },
        {
          title: "Founding deed",
          description: "Public deed signed on March 30, 2026.",
          file: "https://customer-assets.emergentagent.com/job_f05fff24-1793-4250-930b-537d899538c3/artifacts/0mphspgo_Escrtura%20CIEES%20Portugal%20dia%203003%202026.pdf",
        },
      ],
    },
    contact: {
      overline: "Contact",
      title: "Say hello.",
      lead:
        "For entrepreneurs and executives interested in CIEES, for press, or for the Church — write to us. We always reply.",
      fields: { name: "Name", email: "Email", subject: "Subject", message: "Message" },
      successTitle: "Message sent.",
      successBody: "We received your message and will reply shortly.",
      seat: "Seat",
      seatBody: "Praça Damão, 7 · 1400-085 Lisbon · Portugal",
    },
    newsletter: {
      title: "Follow the community",
      body: "Receive news, reflections and important dates from CIEES Portugal.",
      namePlaceholder: "Your name (optional)",
      placeholder: "Your email",
      cta: "Subscribe",
      success: "Subscribed. Thank you!",
    },
    footer: {
      tagline: "Schoenstatt at work.",
      links: "Pages",
      legal: "Institutional",
      seat: "Seat",
      privacy: "Privacy",
      copyright: "© 2026 CIEES Portugal · All rights reserved.",
    },
  },
  es: {
    nav: {
      home: "Inicio",
      about: "Quiénes somos",
      communities: "Comunidades",
      spirituality: "Espiritualidad",
      miami: "Congreso Miami",
      presentation: "Presentación 2026",
      events: "Eventos",
      contact: "Contacto",
      support: "Apoyar",
    },
    common: {
      learnMore: "Saber más",
      register: "Inscribirme",
      send: "Enviar",
      sending: "Enviando…",
      submit: "Enviar",
      thankYou: "¡Gracias!",
      backHome: "Volver al inicio",
      required: "Obligatorio",
      optional: "(opcional)",
      yes: "Sí",
      no: "No",
      readPrayer: "Leer la oración",
      downloadStatutes: "Descargar estatutos",
    },
    home: {
      overline: "Comunidad · Liderazgo · Alianza",
      heroTitle: "Schoenstatt en el trabajo.",
      heroSubtitle:
        "Empresarios y ejecutivos que viven la Alianza de Amor con María, al servicio de una economía más humana, justa e inspirada.",
      ctaPrimary: "Presentación · Septiembre 2026",
      ctaSecondary: "Conocer CIEES",
      sectionAboutOverline: "Nuestra misión",
      sectionAboutTitle: "Líderes inspiradores que humanizan el mundo del trabajo.",
      sectionAboutBody:
        "CIEES Portugal nació el 30 de marzo de 2026, en Lisboa, como rama nacional de la Comunidad Internacional de Empresarios y Ejecutivos Schoenstattianos. Nos inspira la pedagogía del Padre José Kentenich para construir una cultura empresarial fundada en la fe, la dignidad y el bien común.",
      pillars: [
        { title: "Auto-educación", body: "Proponemos itinerarios de auto-educación para empresarios y ejecutivos que viven la Cultura de la Alianza." },
        { title: "Comunidad", body: "Promovemos comunidades locales y la comunión entre líderes." },
        { title: "Retiros", body: "Organizamos retiros y encuentros de reflexión a la luz de la pedagogía kentenichiana." },
        { title: "Testimonio", body: "Transformamos la sociedad mediante el testimonio coherente de los miembros." },
      ],
      eventsOverline: "Próximos pasos",
      eventsTitle: "Dos encuentros para poner en la agenda.",
      septCard: {
        date: "Septiembre 2026 · Lisboa",
        title: "Presentación Formal a Empresarios Portugueses",
        body: "Un encuentro para presentar oficialmente CIEES Portugal a la comunidad empresarial nacional y acoger a los primeros asociados.",
        cta: "Manifestar interés",
      },
      miamiCard: {
        date: "Septiembre 2027 · Miami, EE. UU.",
        title: "Congreso CIEES Internacional",
        body: "El encuentro internacional bienal que reúne a las ramas del CIEES en todo el mundo. Portugal estará presente.",
        cta: "Saber más",
      },
      quoteOverline: "Nuestra misión",
      quote:
        "“Inspirar, evangelizar y humanizar el mundo del trabajo — mediante el ejemplo y el servicio.”",
      quoteAuthor: "CIEES Portugal",
    },
    about: {
      overline: "Quiénes somos",
      title: "Una asociación nueva, con una raíz centenaria.",
      lead:
        "CIEES Portugal — Comunidad Internacional de Empresarios y Ejecutivos Schoenstattianos — es una asociación privada sin fines de lucro, de inspiración cristiana católica y raíz schoenstattiana, con sede en Lisboa.",
      historyTitle: "Historia",
      history:
        "El 30 de marzo de 2026, ocho empresarios y ejecutivos portugueses firmaron la escritura. Nos reunimos después en el Santuario de Schoenstatt para consagrar simbólicamente la obra a la Madre Tres Veces Admirable. La rama portuguesa integra la red internacional del CIEES.",
      missionTitle: "Misión",
      mission:
        "Promover la vivencia y aplicación de la espiritualidad y pedagogía de Schoenstatt en el mundo del trabajo y de la empresa — inspirando, evangelizando y humanizando, mediante el ejemplo y el servicio.",
      finalitiesTitle: "Fines",
      finalities: [
        "Proponer itinerarios de auto-educación para empresarios, ejecutivos y líderes que viven la Cultura de la Alianza de Amor y la pedagogía kentenichiana.",
        "Promover comunidades locales de empresarios y ejecutivos.",
        "Estudiar, profundizar y aplicar la Doctrina Social de la Iglesia en la empresa.",
        "Organizar retiros, encuentros de reflexión y comunión.",
        "Contribuir a la transformación de la sociedad desde el mundo del trabajo.",
        "Colaborar con el Movimiento de Schoenstatt, diócesis y otras instituciones afines.",
      ],
      foundersTitle: "Fundadores",
      founders: [
        { name: "Paulo Jorge de Matos Galvão", role: "Presidente" },
        { name: "Pedro Gonçalves Marques", role: "Vicepresidente" },
        { name: "Manuel Máximo Canavarro Menres Mendes de Almeida", role: "Presidente de la Asamblea" },
        { name: "Hugo Emanuel Ferreira Neves Chambel", role: "Presidente del Consejo Fiscal" },
        { name: "Carlos de Avelar da Costa Freire Correia", role: "Dirección Ejecutiva" },
        { name: "Gonçalo Machado Mendes Barata", role: "Finanzas" },
        { name: "João Pedro Magalhães Paleta", role: "Educación" },
        { name: "José Pedro Rosa Henriques Mendonça", role: "Espiritualidad" },
        { name: "Ana Isabel Nunes Martins", role: "Comunicación" },
      ],
      spiritualAdvisorTitle: "Asesor Espiritual",
      spiritualAdvisor: "P. Borja Coelho de Portugal",
      seatTitle: "Sede",
      seatBody: "Praça Damão, 7 · 1400-085 Lisboa · Portugal",
      mandate: "Mandato presidencial: 3 años",
    },
    spirituality: {
      overline: "Espiritualidad",
      title: "Alianza de Amor con María, al servicio del trabajo.",
      lead:
        "Schoenstatt es un movimiento católico fundado en 1914 por el Padre José Kentenich. Su espiritualidad se centra en la Alianza de Amor con María, la fe práctica en la Divina Providencia y una pedagogía que forma personalidades libres, firmes y apostólicas.",
      shrineTitle: "El Santuario",
      shrineBody:
        "Cada Santuario de Schoenstatt es un lugar de gracia, donde se vive una especial presencia de María como Madre, Reina y Vencedora Tres Veces Admirable. En el Santuario, en Lisboa, entregamos simbólicamente la escritura del CIEES Portugal.",
      covenantTitle: "La Alianza de Amor",
      covenantBody:
        "En el corazón de la espiritualidad de Schoenstatt está la Alianza de Amor con María — un compromiso personal y comunitario de mutua confianza. Aportamos nuestra pequeña contribución de oración, sacrificio y fidelidad; de Ella recibimos la fecundidad que nos transforma y a nuestra misión en el mundo del trabajo.",
      pedagogyTitle: "Pedagogía kentenichiana",
      pedagogyBody:
        "La pedagogía del Padre José Kentenich es una pedagogía de vínculos, de ideal personal y fe práctica en la Divina Providencia. Forma personalidades libres, firmes y apostólicas — capaces de vivir con coherencia el Evangelio en el día a día profesional.",
      itinerariesTitle: "Lo que proponemos",
      itinerariesBody:
        "No somos una escuela ni damos cursos de formación. Proponemos itinerarios de auto-educación — caminos personales y comunitarios que cada empresario y ejecutivo recorre, a su ritmo, en comunidad — complementados por retiros y encuentros de reflexión a la luz de la espiritualidad de Schoenstatt.",
      itinerariesPoints: [
        "Itinerarios personales de auto-educación",
        "Retiros y encuentros de reflexión",
        "Comunidades locales de comunión",
        "Acompañamiento espiritual",
      ],
    },
    miami: {
      overline: "Evento internacional",
      title: "Congreso CIEES Internacional",
      where: "Miami · Estados Unidos",
      when: "Septiembre 2027",
      lead:
        "El encuentro internacional bienal que reúne todas las ramas del CIEES — para el encuentro, la comunión, el intercambio y el discernimiento de rumbo común.",
      portugalDelegation:
        "Portugal participará por primera vez como rama nacional, con una delegación de empresarios y ejecutivos que abrazan la misión.",
      interestTitle: "Manifestar interés en participar",
      interestBody:
        "Si quisiera unirse a la delegación portuguesa en Miami, déjenos sus datos. Le contactaremos con los detalles finales de programa, alojamiento e inversión.",
    },
    presentation: {
      overline: "Presentación a empresarios portugueses",
      title: "Septiembre 2026 · Lisboa",
      lead:
        "Un encuentro formal para presentar CIEES Portugal a la comunidad empresarial nacional. Una velada de reflexión, comunión y misión — para que más empresarios y ejecutivos descubran esta nueva casa.",
      details: [
        { label: "Cuándo", value: "Septiembre 2026 (fecha por confirmar)" },
        { label: "Dónde", value: "Lisboa — lugar por anunciar" },
        { label: "Duración", value: "Por confirmar" },
        { label: "Invitación", value: "Por inscripción (plazas limitadas)" },
      ],
      formTitle: "Reservar su plaza",
      formIntro:
        "Complete el formulario para reservar su presencia. Recibirá un email de confirmación y, más cerca de la fecha, los detalles finales.",
      fields: {
        fullName: "Nombre completo",
        email: "Email",
        phone: "Móvil",
        company: "Empresa",
        role: "Cargo / Función",
        dietary: "Restricciones alimentarias",
        bringGuest: "¿Trae acompañante?",
        guestName: "Nombre del acompañante",
        message: "Mensaje (opcional)",
      },
      successTitle: "Inscripción registrada con gratitud.",
      successBody:
        "Acabamos de enviar una confirmación a su email. Pronto recibirá los detalles finales. Que María nos guíe.",
    },
    downloads: {
      overline: "Documentos",
      title: "Documentos fundadores",
      lead: "Toda obra deja huella. Descargue aquí los documentos que fundan nuestra comunidad.",
      items: [
        {
          title: "Estatutos firmados",
          description: "Texto íntegro de los estatutos del CIEES Portugal, aprobados por los fundadores.",
          file: "https://customer-assets.emergentagent.com/job_f05fff24-1793-4250-930b-537d899538c3/artifacts/aep30toa_Estatutos%20CIEES%20Portugal%20assinados.pdf",
        },
        {
          title: "Escritura de Constitución",
          description: "Escritura pública otorgada el 30 de marzo de 2026.",
          file: "https://customer-assets.emergentagent.com/job_f05fff24-1793-4250-930b-537d899538c3/artifacts/0mphspgo_Escrtura%20CIEES%20Portugal%20dia%203003%202026.pdf",
        },
      ],
    },
    contact: {
      overline: "Contacto",
      title: "Salúdenos.",
      lead:
        "Para empresarios y ejecutivos interesados en CIEES, para prensa o para la Iglesia — escríbanos. Siempre respondemos.",
      fields: { name: "Nombre", email: "Email", subject: "Asunto", message: "Mensaje" },
      successTitle: "Mensaje enviado.",
      successBody: "Hemos recibido su mensaje y le responderemos en breve.",
      seat: "Sede",
      seatBody: "Praça Damão, 7 · 1400-085 Lisboa · Portugal",
    },
    newsletter: {
      title: "Acompañe la comunidad",
      body: "Reciba noticias, reflexiones y fechas relevantes de CIEES Portugal.",
      namePlaceholder: "Su nombre (opcional)",
      placeholder: "Su email",
      cta: "Suscribirse",
      success: "Suscrito. ¡Gracias!",
    },
    footer: {
      tagline: "Schoenstatt en el trabajo.",
      links: "Páginas",
      legal: "Institucional",
      seat: "Sede",
      privacy: "Privacidad",
      copyright: "© 2026 CIEES Portugal · Todos los derechos reservados.",
    },
  },
};

export const LANGS = [
  { code: "pt", label: "PT", name: "Português" },
  { code: "en", label: "EN", name: "English" },
  { code: "es", label: "ES", name: "Español" },
];

